import { Router } from "@reach/router";
import { ContentContainer } from "../components/Layout";
import RfqOverview from "pages/GuestFlow/RfqOverviews/RfqOverview";
import { Breadcrumbs } from "components/Breadcrumb";
import { Box } from "@chakra-ui/react";
import ViewRFQPage from "pages/RFQ/RFQ/ViewRFQ/ViewRFQPage";
import { RfxDataProvider } from "newui/features/Rfx/data-provider/RfxDataProvider";
import { RfxSubmissionDataProvider } from "newui/features/Rfx/data-provider/RfxSubmissionDataProvider";
import RFQPreview from "newui/features/Rfx/Submission/RFQPreview";
import GuestRfxSubmissionRedirect from "app/GuestRfxSubmissionRedirect";
import SharedCompany from "pages/GuestFlow/SharedCompany/SharedCompany";
import { NotFound } from "newui/features/ErrorPages/NotFound";
import { AppMenu } from "newui/features/AppMenu";
import { GuestEvaluationPanelPage } from "newui/features/Rfx/Evaluation";
import { RfxReadOnlyPreviewPage } from "newui/features/Rfx/pages/RfxReadOnlyPreviewPage";

export const GuestComponent = ({ path: _path }) => {
	return (
		<Box
			display="flex"
			flexWrap="nowrap"
			width="100%"
			minH="100vh"
		>
			<AppMenu
				name="sdfsf"
				logo="sdf"
			/>
			<ContentContainer id="element-scroll">
				<Breadcrumbs ignoreCompany={true} />
				<Router primary={false}>
					{/* Guest Submission */}
					<GuestRfxSubmissionRedirect path="request-for-quote/:rfxId/:currentTab" />
					<RfxSubmissionDataProvider
						path="rfx/:rfxRouteId/submission"
					>
						<RFQPreview
							path="/"
						/>
						<RFQPreview
							path=":currentTab"
						/>
						<RFQPreview
							path=":currentTab/:contextId"
							isGuest
						/>
					</RfxSubmissionDataProvider>

					{/* RFx Approval Process */}
					<RfxDataProvider path="rfx/:rfxRouteId/view-approval">
						{/* A guest pre-approver holds no supplier invite and is viewing
							the RFx before any submissions exist, so guest/show-submission
							would always 403 here. Don't call it. */}
						<RfxSubmissionDataProvider
							fetchGuestSubmission={false}
							path="/"
						>
							<ViewRFQPage path="/" />
						</RfxSubmissionDataProvider>
					</RfxDataProvider>

					{/* RFx Evaluation Process */}
					<RfxDataProvider path="rfx/:rfxRouteId/evaluation">
						<GuestEvaluationPanelPage path="/*" />
					</RfxDataProvider>

					{/* RFx read-only preview (PRO-637 Task 011) — pre-accept guest deep-link
						entry point. Addressed by RFx uuid, NOT the numeric `rfxRouteId` used
						above by RfxDataProvider/RfxSubmissionDataProvider. */}
					<RfxReadOnlyPreviewPage path="rfx/:rfxUuid/preview" />

					{/* RFx Grid view for Guests */}
					<RfqOverview path="/rfx" />
					{/*  */}

					{/* <RfxSubmissionDataProvider isGuest={true} path="rfx/:rfxRouteId" useParentRfxData={false}> */}

					{/* <RFQPreview
							path=":currentTab"
							isGuest
						/> */}
					{/* </RfxSubmissionDataProvider> */}

					<SharedCompany path="/shared-companies" />
					<NotFound default />
				</Router>
			</ContentContainer>
		</Box>
	);
};

export const Guest = GuestComponent;
